goog.provide("shadow.js.shim.module$$carbon$icons_react$es$send$32");
goog.provide("module$shadow_js_shim_module$$carbon$icons_react$es$send$32");
shadow.js.shim.module$$carbon$icons_react$es$send$32 = shadow.js.nativeProvides["@carbon/icons-react/es/send/32"] = shadow$bridge("@carbon/icons-react/es/send/32");
module$shadow_js_shim_module$$carbon$icons_react$es$send$32.default = shadow.js.shim.module$$carbon$icons_react$es$send$32;
